
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandT as ObiOwnShipNoCommandTElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-t.js';
 
 
 

 
 export const ObiOwnShipNoCommandT = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-t',
   elementClass: ObiOwnShipNoCommandTElement,
   events: {
     
   }
  });
 
 